import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import AutocompleteSelector from 'ui-coopeuch-autocomplete-selector';
import { stepperAction } from '../../../../application/actions/stepper';
import { Wrapper } from './styles';
import CollapseItem from '../../atoms/CollapseCard';
import { sucursalActions } from '../../../../application/actions/sucursal';

const SucursalesTemplate = ({ activeMenu, regiones, region, comuna, buscarSucursalCercana, setComunaAux, setRegionAux }) => {
  const dispatch = useDispatch();

  const [comunas, setComunas] = useState({});
  const [sucursales, setSucursales] = useState([]);
  const [regionSelected, setRegionSelected] = useState({});
  const [comunaSelected, setComunaSelected] = useState({});

  const [activeIndex, setActiveIndex] = useState(null);

  const onSelectSucursal = (item, index) => {
    setActiveIndex(activeIndex === index ? index : index);
    dispatch(sucursalActions.setSucursalSeleccionada(item))
  }

  const handleSelectionRegion = (e) => {
    setRegionSelected(e);
    setRegionAux(e.id);
    setComunaSelected({});
    setComunas(e.comunas)
    setSucursales([]);
    dispatch(sucursalActions.setSucursalSeleccionada(null))
  }

  const handleSelectionComuna = (e) => {
    setComunaSelected(e);
    setComunaAux(e.id);
    setSucursales(e.sucursales);
    setActiveIndex(null);
    dispatch(sucursalActions.setSucursalSeleccionada(null))
  }

  useEffect(() => {
    if (sucursales.length === 1 && buscarSucursalCercana) {
      onSelectSucursal(sucursales[0], 0);
    }
  }, [sucursales])

  useEffect(() => {
    try {
      dispatch(stepperAction.fetchStepper(activeMenu));
      if(buscarSucursalCercana){
        const regionSelecionada = regiones.filter( r => r.id === region);
        if(regionSelecionada.length > 0){
          handleSelectionRegion(regionSelecionada[0]);
          const comunaSelecionada = regionSelecionada[0].comunas.filter( c => c.id === comuna);
          if(comunaSelecionada.length > 0){
            handleSelectionComuna(comunaSelecionada[0]);
          }
        }
      }
    } catch {
      // do nothing
    }
  }, [activeMenu, buscarSucursalCercana]);

  return (
    <Wrapper>
      <Card>
        <CardTitlePrimary title="¿Dónde la quieres retirar?" />
        <CardContent>
          <form className="formulario-sucursal">
            <AutocompleteSelector
              items={regiones}
              value={regionSelected}
              name_attr_value="id"
              name_text_node="region"
              idElement="region-select"
              label="Región"
              placeholder="Selecciona"
              onSelection={handleSelectionRegion}
            />

            <div className={JSON.stringify(comunas) !== '{}' ? 'formulario-comuna' : ''}>

              {
                JSON.stringify(comunas) !== '{}' &&
                <AutocompleteSelector
                  items={comunas}
                  value={comunaSelected}
                  name_attr_value="id"
                  name_text_node="nombre"
                  idElement="region-select"
                  label="Comuna"
                  placeholder="Selecciona"
                  onSelection={handleSelectionComuna}
                />
              }

            </div>

          </form>

          <div>
            {
              sucursales.length > 0 &&
              <div className="sucursales-container">
                <p className="subtitle">Selecciona una sucursal</p>
                <div>
                  <CollapseItem
                    list={sucursales}
                    onSelectItem={onSelectSucursal}
                    activeIndex={activeIndex}
                  />
                </div>

              </div>
            }

          </div>
        </CardContent>
      </Card>
    </Wrapper>
  )
}
SucursalesTemplate.propTypes = {
  activeMenu: PropTypes.number,
  regiones: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  region: PropTypes.string,
  comuna: PropTypes.string,
  buscarSucursalCercana: PropTypes.bool,
  setComunaAux: PropTypes.func.isRequired,
  setRegionAux: PropTypes.func.isRequired
};

SucursalesTemplate.defaultProps = ({
  activeMenu: '',
  region: '',
  comuna: '',
  buscarSucursalCercana: false
});

export default SucursalesTemplate;